import { Notification, NotificationBody } from "@adeccoux/tag-ds";
import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BaseContext } from "../../App";
import SesHeader from "../header";

const WarmupComplete = ({ backtoInst, handleMainTestStart }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { setWarmupDoneShown } = useContext(BaseContext);
    const phrases = location.state.user.siteConfig.phrases;
    const timed =
        location.state.test.timeLimit != 0 ||
        location.state.test.timedByTopic ||
        location.state.test.timeByQuestion;

    const handleStart = () => {
        setWarmupDoneShown(false);
        handleMainTestStart();
    };

    const backtoInstruction = () => {
        setWarmupDoneShown(false);
        backtoInst();
    };

    const restartWarmUp = () => {
        setWarmupDoneShown(false);
        navigate("/instructions", {
            state: { ...location.state, restartWarmUp: true },
        });
    };

    return (
        <>
            <SesHeader clientCobranding={location.state?.cobrandingLink} isWarmUp={false} />
            <div className="flex_col g2 align-items_start xpert-align-self-stretch">
                <div className="flex_col g2 align-items_start xpert-align-self-stretch justify-content_center text-01">
                    <span style={{ fontSize: "40px" }} className="material-icons-outlined">
                        sentiment_satisfied_alt
                    </span>
                    <h3>{phrases?.["26000063"]}</h3>
                </div>
                {timed && (
                    <Notification
                        className="docs"
                        data-testid="notification"
                        icon={<span className="material-icons-outlined">info</span>}
                        show
                        info
                    >
                        <NotificationBody className="tost_message">
                            {phrases?.["26000065"]}
                        </NotificationBody>
                    </Notification>
                )}
            </div>
            <hr />
            <div className="flex flex_col_mobile g2 justify-content_between full-width">
                <div className="flex flex_col_mobile g2">
                    <button
                        type="button"
                        className="button-secondary text_uppercase"
                        onClick={backtoInstruction}
                    >
                        {phrases?.["1000229"]}
                    </button>
                    <button
                        type="button"
                        className="button-secondary text_uppercase"
                        onClick={restartWarmUp}
                    >
                        {phrases?.["26000064"]}
                    </button>
                </div>
                <button className="text_uppercase" type="button" onClick={handleStart}>
                    {phrases?.["11070"]}
                </button>
            </div>
        </>
    );
};
export default WarmupComplete;
